export default __webpack_public_path__ + "static/media/data3.8ed479de.jpeg";